<template>
  <v-container id="pmd-scope" fluid>
    <v-row>
      <v-col cols="12" md="3">
        <v-card class="scope-sidebar" outlined>
          <v-card-title class="subtitle-2 font-weight-bold d-flex align-center">
            <div class="sidebar-header">
              <div class="sidebar-kicker">Protótipo navegável</div>
              <div class="sidebar-title">Gestão de Projetos (PDM)</div>
            </div>
          </v-card-title>

          <v-divider class="mx-4"></v-divider>

          <v-list dense nav>
            <v-list-item
              v-for="item in navigation"
              :key="item.text"
              :href="item.href"
              class="py-2"
            >
              <v-list-item-content>
                <v-list-item-title class="subtitle-2">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="9">
        <v-card outlined class="mb-6" id="contexto">
          <v-card-title class="headline font-weight-bold">Escopo do Módulo</v-card-title>
          <v-card-text class="body-2 grey--text">
            Resumo das funcionalidades planejadas para o módulo de Gestão de Projetos do Programa de Desenvolvimento Municipal (PDM).
          </v-card-text>
        </v-card>

        <v-card
          v-for="section in sections"
          :key="section.title"
          :id="section.anchor"
          class="mb-4"
          outlined
        >
          <v-card-title class="subtitle-1 font-weight-bold">
            {{ section.title }}
          </v-card-title>
          <v-card-text class="body-2">
            <template v-if="section.items">
              <ul class="mb-0">
                <li v-for="item in section.items" :key="item" class="mb-1">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template v-else>
              <p class="mb-0">
                {{ section.description }}
              </p>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PmdScope",
  data() {
    return {
      navigation: [
        { text: "Dashboard", href: "#dashboard" },
        { text: "Projetos", href: "#projetos" },
        { text: "Projeto - Detalhe", href: "#projeto-detalhe" },
        { text: "Relatórios", href: "#relatorios" },
        { text: "Governança", href: "#governanca" },
        { text: "Configurações", href: "#configuracoes" },
        { text: "Escopo", href: "#contexto" }
      ],
      sections: [
        {
          title: "Contexto",
          anchor: "dashboard",
          description:
            "Módulo acoplado ao SSDT/Cidade Empreendedora por município, sem alterar fluxos existentes."
        },
        {
          title: "Catálogo PDM",
          anchor: "projetos",
          items: [
            "Cadastros de eixos, objetivos e projetos",
            "Projetos vinculados a 5W2H por PDM"
          ]
        },
        {
          title: "KPIs e OKRs",
          anchor: "projeto-detalhe",
          items: [
            "Templates por eixo, projetos e indicadores",
            "Aproximação com dados de cadastros do PDM"
          ]
        },
        {
          title: "Acompanhamento",
          anchor: "relatorios",
          items: [
            "Grupos de trabalho com ações e status",
            "Gestão de prazos e responsáveis"
          ]
        },
        {
          title: "Monitoramento",
          anchor: "governanca",
          items: [
            "Dashboards de acompanhamento (RAG, progresso, riscos)",
            "Check-ins trimestrais e relatórios mensal/trimestral/anual"
          ]
        },
        {
          title: "Governança",
          anchor: "configuracoes",
          items: [
            "Atas de reunião com histórico de decisões",
            "Fluxo de aprovações e alertas"
          ]
        },
        {
          title: "Integrações",
          anchor: "integracoes",
          items: [
            "Sincronização com repositório de usuários e grupos",
            "Indicadores integrados aos módulos de Contratos e Projetos"
          ]
        },
        {
          title: "Permissões",
          anchor: "permissoes",
          items: [
            "Admin", "Gestor Regional", "Gestor Municipal", "Consultor", "Comitê"
          ]
        },
        {
          title: "Auditoria & LGPD",
          anchor: "auditoria-lgpd",
          items: [
            "Trilhas de auditoria por município",
            "Registro de acessos e guarda de dados conforme LGPD"
          ]
        },
        {
          title: "Observação",
          anchor: "observacao",
          description: "Use o menu lateral para navegar pelos mockups e cenários do módulo."
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#pmd-scope {
  padding-top: 24px;

  .scope-sidebar {
    background-color: #f5f7fb;

    .sidebar-header {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .sidebar-kicker {
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #4f5b62;
      letter-spacing: 0.08em;
    }

    .sidebar-title {
      font-size: 1.125rem;
      color: #1a237e;
      font-weight: 600;
    }
  }

  ul {
    padding-left: 18px;
  }
}
</style>
